/**
 * @typedef {import('vuex').Module} Module
 */
/**
 * @type {Module}
 */
export const store = {
  namespaced: true,
  state: () => ({
    width: 0,
    height: 0
  }),
  actions: {
    check ({ state, commit, rootState }) {
      console.log('check', arguments)
    }
  },
  mutations: {
    update (state, opts) {
      // console.log(arguments)
      state.width = opts.width
      state.height = opts.height
    }
  }
}
